import * as types from "../constants/actionTypes"
import initialState from "./initialState"

export default function vehicleGroupReducer(state = initialState.vehicleGroups, action) {
    switch (action.type) {
        case types.VEHICLE_GROUPS.GET.REQUEST:
            return {
                ...state,
                isFetching: true,
            }
        case types.VEHICLE_GROUPS.GET.SUCCESS:
            return {
                ...state,
                data: action.result.data.GetVehicleGroups,
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.GET.FAILURE:
            return {
                ...state,
                data: null,
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.DELETE.REQUEST:
            return {
                ...state,
                isFetching: true,
            }
        case types.VEHICLE_GROUPS.DELETE.SUCCESS:
            return {
                ...state,
                data: state.data.filter(e => e._id !== action.result._id),
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.DELETE.FAILURE:
            return {
                ...state,
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.CLEAR:
            return {
                ...state,
                data: null,
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.CREATE.REQUEST:
            return {
                ...state,
                isFetching: true,
            }
        case types.VEHICLE_GROUPS.CREATE.SUCCESS:
            return {
                ...state,
                data: state.data.concat(action.result.data.CreateVehicleGroups),
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.CREATE.FAILURE:
            return {
                ...state,
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.SET.REQUEST:
            return {
                ...state,
                isFetching: true,
            }
        case types.VEHICLE_GROUPS.SET.SUCCESS:
            return {
                ...state,
                data: state.data.map(e => e._id === action.result.data.UpdateVehicleGroups._id 
                    ? action.result.data.UpdateVehicleGroups : e),
                isFetching: false,
            }
        case types.VEHICLE_GROUPS.SET.FAILURE:
            return {
                ...state,
                isFetching: false,
            }
        default:
            return state
    }
}
